module.exports = __webpack_public_path__ + "static/media/dtrc-active.cda33239.png";